import { render } from "./fabuAdd.vue?vue&type=template&id=d2a0d0e6&scoped=true"
import script from "./fabuAdd.vue?vue&type=script&lang=js"
export * from "./fabuAdd.vue?vue&type=script&lang=js"

import "./fabuAdd.vue?vue&type=style&index=0&id=d2a0d0e6&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2a0d0e6"]])

export default __exports__